import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import borders from 'assets/theme/base/borders';
import typography from 'assets/theme/base/typography';
import rgba from 'assets/theme/function/rgba';

const { borderRadius } = borders;

const tab = {
    styleOverrides: {
        root: {
            flex: 1,
            maxWidth: pxToRem(398),
            height: pxToRem(50),
            fontSize: typography.size.lg,
            fontWeight: typography.fontWeightMedium,
            backgroundColor: rgba(colors.secondary.light, 0.8),
            color: colors.common.white,

            '&.Mui-selected': {
                color: colors.common.white,
                backgroundColor: colors.primary.light,
                borderRadius: borderRadius.xl,
            },
        },
    },
};

export default tab;
